import React from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";

import {
    PatientLayoutAnonymous,
    PatientLayoutAsideAnonymous,
    redirectUrlAfterAuthPath,
    PageTitle,
} from "@rdcs/dap-front-library";

import { LOGIN_URL } from "../../utils/utils";

const LoginScreen = ({ user }) => {
    const location = useLocation();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (user) {
            navigate(redirectUrlAfterAuthPath(location.patientFinalized ? "/mes-soignants" : "/mes-recommandations"));
        }
    }, []);

    return (
        !user && (
            <PageTitle title="Timkl - Connexion">
                <PatientLayoutAnonymous>
                    <div className="grid credentials__container">
                        <PatientLayoutAsideAnonymous />
                        <main className="col-sm-50 credentialsMain__container">
                            <div className="credentialsMain">
                                <div className="credentials__title">
                                    Connectez-vous à <br />
                                    Diabète Adhérence Plateforme
                                </div>
                                <div>
                                    <a href={LOGIN_URL} className="button button__primaryButton mx-0">
                                        S'identifier
                                    </a>
                                </div>
                            </div>
                            <div className="credentialsFooter txtUnderline">
                                <Link to="/cgu">CGU</Link>
                            </div>
                        </main>
                    </div>
                </PatientLayoutAnonymous>
            </PageTitle>
        )
    );
};

LoginScreen.propTypes = {
    user: PropTypes.object,
};

const mapStateToProps = ({ auth: { user } }) => ({ user });

export default connect(mapStateToProps)(LoginScreen);
